<template>
  <Modal
    title="注册资料"
    v-model="visibleThis"
    width="1000"
    :mask-closable="false"
    @on-visible-change="onVisibleChange"
  >
    <div v-if="loading" class="apply-loading">
      <Spin fix></Spin>
    </div>
    <div v-else-if="!applyData" class="apply-empty">暂无注册资料</div>
    <Tabs v-else type="card" v-model="tabName">
      <TabPane label="个人信息" name="1">
        <Row :gutter="16">
          <Col :span="12">
            <div class="field">
              <label>头像：</label>
              <div class="field-value">
                <img v-if="mediaUrl(applyData.avatar)" class="avatar" :src="mediaUrl(applyData.avatar)" alt="">
                <span v-else class="empty">未上传</span>
              </div>
            </div>
          </Col>
          <Col :span="12">
            <div class="field"><label>姓名：</label><span>{{ display(applyData.fullName) }}</span></div>
          </Col>
          <Col :span="12">
            <div class="field"><label>性别：</label><span>{{ genderText(applyData.gender) }}</span></div>
          </Col>
          <Col :span="12">
            <div class="field"><label>出生日期：</label><span>{{ display(applyData.birthday) }}</span></div>
          </Col>
          <Col :span="12">
            <div class="field"><label>年龄：</label><span>{{ display(applyData.age) }}</span></div>
          </Col>
          <Col :span="12">
            <div class="field"><label>国籍：</label><span>{{ display(applyData.nationality) }}</span></div>
          </Col>
          <Col :span="12">
            <div class="field"><label>护照签发国：</label><span>{{ display(applyData.passportCountry) }}</span></div>
          </Col>
          <Col :span="12">
            <div class="field"><label>婚姻状况：</label><span>{{ display(applyData.maritalStatus) }}</span></div>
          </Col>
          <Col :span="12">
            <div class="field"><label>种族：</label><span>{{ display(applyData.ethnicity) }}</span></div>
          </Col>
          <Col :span="12">
            <div class="field"><label>所在国家：</label><span>{{ display(applyData.locationCountry) }}</span></div>
          </Col>
          <Col :span="12">
            <div class="field"><label>省/州：</label><span>{{ display(applyData.locationState) }}</span></div>
          </Col>
          <Col :span="12">
            <div class="field"><label>城市：</label><span>{{ display(applyData.locationCity || applyData.townOrCity) }}</span></div>
          </Col>
          <Col :span="24">
            <div class="field"><label>健康状况：</label><span>{{ display(applyData.health) }}</span></div>
          </Col>
        </Row>
      </TabPane>

      <TabPane label="教育背景" name="2">
        <Row :gutter="16">
          <Col :span="12">
            <div class="field"><label>最高学历：</label><span>{{ display(applyData.highestQualification) }}</span></div>
          </Col>
          <Col :span="12">
            <div class="field"><label>毕业年份：</label><span>{{ display(applyData.yearOfGraduation) }}</span></div>
          </Col>
          <Col :span="12">
            <div class="field"><label>毕业院校：</label><span>{{ display(applyData.school) }}</span></div>
          </Col>
          <Col :span="12">
            <div class="field"><label>专业：</label><span>{{ display(applyData.major) }}</span></div>
          </Col>
        </Row>
      </TabPane>

      <TabPane label="当前工作" name="3">
        <Row :gutter="16">
          <Col :span="12">
            <div class="field"><label>当前工作：</label><span>{{ display(applyData.currentJob) }}</span></div>
          </Col>
          <Col :span="12">
            <div class="field"><label>工作时间：</label><span>{{ display(applyData.currentJobSchedule) }}</span></div>
          </Col>
          <Col :span="24">
            <div class="field"><label>度假计划：</label><span>{{ display(applyData.holidayPlan) }}</span></div>
          </Col>
        </Row>
        <div class="section-title">教学经历</div>
        <div v-if="!(applyData.teachingExperiences && applyData.teachingExperiences.length)" class="empty">暂无教学经历</div>
        <div
          v-for="(exp, idx) in (applyData.teachingExperiences || [])"
          :key="'exp-' + idx"
          class="exp-card"
        >
          <Row :gutter="16">
            <Col :span="12"><div class="field"><label>时间：</label><span>{{ display(exp.timePeriod) }}</span></div></Col>
            <Col :span="12"><div class="field"><label>公司：</label><span>{{ display(exp.company) }}</span></div></Col>
            <Col :span="12"><div class="field"><label>职位：</label><span>{{ display(exp.position) }}</span></div></Col>
            <Col :span="12"><div class="field"><label>每天课时：</label><span>{{ display(exp.lessonsPerDay) }}</span></div></Col>
            <Col :span="12"><div class="field"><label>课时时长：</label><span>{{ display(exp.lessonDuration) }}</span></div></Col>
            <Col :span="12"><div class="field"><label>时薪：</label><span>{{ display(exp.hourlyRate) }}</span></div></Col>
            <Col :span="24"><div class="field"><label>离职原因：</label><span>{{ display(exp.leaveReason) }}</span></div></Col>
          </Row>
        </div>
      </TabPane>

      <TabPane label="教学经历与证书" name="4">
        <Row :gutter="16">
          <Col :span="12">
            <div class="field"><label>是否有证书：</label><span>{{ ynText(applyData.hasCertificate) }}</span></div>
          </Col>
          <template v-if="applyData.hasCertificate === 'Y'">
            <Col :span="12">
              <div class="field">
                <label>TEFL：</label>
                <a v-if="mediaUrl(applyData.certificateTefl)" @click="openUrl(mediaUrl(applyData.certificateTefl))">查看</a>
                <span v-else class="empty">未上传</span>
              </div>
            </Col>
            <Col :span="12">
              <div class="field">
                <label>TESOL：</label>
                <a v-if="mediaUrl(applyData.certificateTesol)" @click="openUrl(mediaUrl(applyData.certificateTesol))">查看</a>
                <span v-else class="empty">未上传</span>
              </div>
            </Col>
            <Col :span="12"><div class="field"><label>TEYL：</label><span>{{ ynText(applyData.certTeyl) }}</span></div></Col>
            <Col :span="12"><div class="field"><label>其他：</label><span>{{ ynText(applyData.certOthers) }}</span></div></Col>
            <Col :span="24"><div class="field"><label>其他说明：</label><span>{{ display(applyData.certOthersText) }}</span></div></Col>
          </template>
          <Col :span="24">
            <div class="field">
              <label>可教科目：</label>
              <span>{{ subjectsText(applyData.teachableSubjects) }}</span>
            </div>
          </Col>
        </Row>
      </TabPane>

      <TabPane label="课表与设备" name="5">
        <div class="section-title">高峰课表</div>
        <div class="schedule-wrap">
          <table class="schedule-table">
            <thead>
              <tr>
                <th>时段</th>
                <th v-for="day in courseDays" :key="day">{{ day }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="slot in courseSlots" :key="slot">
                <td>{{ slot }}</td>
                <td v-for="day in courseDays" :key="day + '-' + slot">{{ scheduleSymbol(day, slot) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <Row :gutter="16" style="margin-top: 12px;">
          <Col :span="12"><div class="field"><label>CPU：</label><span>{{ display(applyData.cpu) }}</span></div></Col>
          <Col :span="12"><div class="field"><label>备用设备：</label><span>{{ display(applyData.backupDevices) }}</span></div></Col>
          <Col :span="12"><div class="field"><label>上行网速：</label><span>{{ display(applyData.upSpeed) }}</span></div></Col>
          <Col :span="12"><div class="field"><label>下行网速：</label><span>{{ display(applyData.downSpeed) }}</span></div></Col>
          <Col :span="12"><div class="field"><label>备用网速：</label><span>{{ display(applyData.backUpInternetSpeed) }}</span></div></Col>
          <Col :span="12"><div class="field"><label>备用电源：</label><span>{{ display(applyData.backUpPower) }}</span></div></Col>
          <Col :span="12"><div class="field"><label>网络供应商：</label><span>{{ display(applyData.networkProviders) }}</span></div></Col>
          <Col :span="12"><div class="field"><label>月费：</label><span>{{ display(applyData.monthlyNetworkFee) }}</span></div></Col>
          <Col :span="12"><div class="field"><label>ClassIn 账号：</label><span>{{ display(applyData.classinAccount) }}</span></div></Col>
          <Col :span="12"><div class="field"><label>ClassIn 类型：</label><span>{{ display(applyData.classinAccountType) }}</span></div></Col>
          <Col :span="12"><div class="field"><label>ClassIn 是否自有：</label><span>{{ ynText(applyData.classinOwn) }}</span></div></Col>
        </Row>
      </TabPane>

      <TabPane label="职位信息" name="6">
        <Row :gutter="16">
          <Col :span="12"><div class="field"><label>预计开课日：</label><span>{{ display(applyData.startTeachDate) }}</span></div></Col>
          <Col :span="12"><div class="field"><label>期望时薪：</label><span>{{ display(applyData.expectSalary) }}</span></div></Col>
          <Col :span="12"><div class="field"><label>招聘来源：</label><span>{{ display(applyData.jobSource) }}</span></div></Col>
          <Col :span="12"><div class="field"><label>时差：</label><span>{{ display(applyData.timeDiff) }}</span></div></Col>
          <Col :span="12"><div class="field"><label>时区：</label><span>{{ display(applyData.timezone) }}</span></div></Col>
          <Col :span="12"><div class="field"><label>紧急电话：</label><span>{{ display(applyData.emergencyPhone) }}</span></div></Col>
          <Col :span="12"><div class="field"><label>紧急联系人关系：</label><span>{{ display(applyData.emergencyRelationship) }}</span></div></Col>
          <Col :span="12">
            <div class="field">
              <label>简历：</label>
              <a v-if="mediaUrl(applyData.cv)" @click="openUrl(mediaUrl(applyData.cv))">查看</a>
              <span v-else class="empty">未上传</span>
            </div>
          </Col>
          <Col :span="12">
            <div class="field">
              <label>自我介绍视频：</label>
              <a v-if="mediaUrl(applyData.introduceVideo)" @click="openUrl(mediaUrl(applyData.introduceVideo))">查看</a>
              <span v-else class="empty">未上传</span>
            </div>
          </Col>
        </Row>
      </TabPane>
    </Tabs>
    <div slot="footer">
      <Button type="default" size="large" @click="visibleThis = false">关闭</Button>
    </div>
  </Modal>
</template>

<script>
  export default {
    name: 'TchApplyFormModal',
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      tchId: {
        type: [Number, String],
        default: null
      }
    },
    data () {
      return {
        visibleThis: this.visible,
        loading: false,
        applyData: null,
        tabName: '1',
        courseDays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
        courseSlots: [
          '6:00pm-6:30pm',
          '6:30pm-7:00pm',
          '7:00pm-7:30pm',
          '7:30pm-8:00pm',
          '8:00pm-8:30pm',
          '8:30pm-9:00pm',
          '9:00pm-9:30pm'
        ],
        scheduleMap: {}
      }
    },
    watch: {
      visible (val) {
        this.visibleThis = val
        if (val) {
          this.loadApply()
        }
      },
      visibleThis (val) {
        if (!val) {
          this.$emit('on-close')
        }
      }
    },
    methods: {
      onVisibleChange (val) {
        if (!val) {
          this.$emit('on-close')
        }
      },
      display (val) {
        if (val === null || val === undefined || val === '') {
          return '未填写'
        }
        return val
      },
      genderText (val) {
        if (val === 1 || val === '1') {
          return '男'
        }
        if (val === 2 || val === '2') {
          return '女'
        }
        return this.display(val)
      },
      ynText (val) {
        if (val === 'Y' || val === 'y') {
          return '是'
        }
        if (val === 'N' || val === 'n') {
          return '否'
        }
        return this.display(val)
      },
      subjectsText (list) {
        if (!list || !list.length) {
          return '未填写'
        }
        return list.join('、')
      },
      mediaUrl (value) {
        if (!value) {
          return ''
        }
        if (String(value).indexOf('http') === 0) {
          return value
        }
        return 'https://medias.kouyujie.cn/' + value
      },
      openUrl (url) {
        if (url) {
          window.open(url)
        }
      },
      toDisplaySlot (hhmm) {
        const raw = String(hhmm || '').replace('pm', '').replace('am', '')
        const parts = raw.split(':')
        let hour = parseInt(parts[0], 10)
        const minute = parts[1] || '00'
        if (isNaN(hour)) {
          return ''
        }
        if (hour > 12) {
          hour = hour - 12
        }
        return hour + ':' + minute + 'pm'
      },
      buildScheduleMap (rows) {
        const map = {}
        const list = rows || []
        const self = this
        list.forEach(function (row) {
          if (!row || !row.week || !row.startTime || !row.endTime) {
            return
          }
          const day = self.courseDays[Number(row.week) - 1]
          if (!day) {
            return
          }
          const slot = self.toDisplaySlot(row.startTime) + '-' + self.toDisplaySlot(row.endTime)
          const key = day + '-' + slot
          const status = row.status || ''
          if (status === 'available') {
            map[key] = '√'
          } else if (status === 'unsure') {
            map[key] = '?'
          } else if (status === 'unavailable') {
            map[key] = '×'
          } else {
            map[key] = '-'
          }
        })
        return map
      },
      scheduleSymbol (day, slot) {
        const val = this.scheduleMap[day + '-' + slot]
        return val || '-'
      },
      loadApply () {
        const self = this
        self.tabName = '1'
        self.applyData = null
        self.scheduleMap = {}
        if (!self.tchId) {
          return
        }
        self.loading = true
        self.$http.get('/tch/apply?tchId=' + self.tchId).then(function (res) {
          self.loading = false
          if (res && res.status === 'ok') {
            self.applyData = res.data || null
            if (self.applyData) {
              self.scheduleMap = self.buildScheduleMap(self.applyData.workTimes)
            }
            return
          }
          self.$Message.error('加载注册资料失败')
        }).catch(function () {
          self.loading = false
          self.$Message.error('加载注册资料失败')
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .apply-loading {
    position: relative;
    min-height: 180px;
  }

  .apply-empty {
    padding: 40px 0;
    text-align: center;
    color: #999;
  }

  .field {
    margin-bottom: 12px;
    line-height: 22px;
    word-break: break-all;

    label {
      color: #666;
      margin-right: 4px;
      white-space: nowrap;
    }
  }

  .field-value {
    display: inline-block;
    vertical-align: middle;
  }

  .empty {
    color: #999;
  }

  .avatar {
    width: 56px;
    height: 56px;
    border-radius: 50%;
    object-fit: cover;
  }

  .section-title {
    margin: 8px 0 12px;
    font-weight: 600;
  }

  .exp-card {
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 8px 12px 0;
    margin-bottom: 12px;
    background: #fafafa;
  }

  .schedule-wrap {
    overflow-x: auto;
  }

  .schedule-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;

    th, td {
      border: 1px solid #e0e0e0;
      padding: 6px 8px;
      text-align: center;
    }

    th {
      background: #f5f5f5;
    }
  }
</style>



// WEBPACK FOOTER //
// TchApplyFormModal.vue?4d5998d8